import { memo } from "react";
import PinnedIcon from "components/icons/pinned.svg?react";
import PinnedFilledIcon from "components/icons/pinnedFilled.svg?react";
import "./PinButton.scss";

interface IPinButton {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  pinned?: boolean;
}

export const PinButton: React.FC<IPinButton> = memo(({
  onClick,
  pinned = false
}) => {
  return (
    <button
      className="PinButton"
      onClick={onClick}
      aria-label="pin button"
    >
      {pinned ? <PinnedFilledIcon /> : <PinnedIcon />}
    </button>
  );
});
